import api from '../../../services/api';

export const adminUserService = {
  list: () => api.get('/users'),
  approve: (id: string) => api.put(`/users/${id}/approve`),
  block: (id: string) => api.put(`/users/${id}/block`),
  setRole: (id: string, role: string) => api.put(`/users/${id}/role`, { role }),
};
